/*
**  @desc:    搜狐统计服务中的几种统计方式
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-19
*/

import BaseStat from './base-stat';
import Cookie from 'js-cookie';
import Util from '../_utils/util';

var SohuStat = (function() {
    var base = '//pv.sohu.com/';
    var serviceMap = {
        'pv': 'pv.gif',
        'ev': 'ev.gif',
        'click': 'click.gif',
        'content_ev': 'content_ev.gif',
        'prom_ev': 'prom_ev.gif',
        'prom_pv': 'prom_pv.gif',
        'action': 'action.gif'
    };
    var SUV = Cookie.get('SUV') || Util.getTmpUUID();

    function sendStatistics(type, params) {
        var baseUrl = base + serviceMap[type];
        params.SUV = SUV;
        BaseStat.sendStatistics(baseUrl, params);
    }

    function sendActionStat(actionId) {
        sendStatistics('action', {
            actionId: actionId
        });
    }

    function sendPvStat(params) {
        var baseUrl = base + serviceMap['pv'];
        BaseStat.sendStatistics(baseUrl, {});
    }

    return {
        sendStatistics: sendStatistics,
        sendActionStat: sendActionStat,
        sendPvStat : sendPvStat
    };
})();

export default SohuStat;


// WEBPACK FOOTER //
// ./src/statistics/sohu-stat.js